import { uploadData, getUrl } from 'aws-amplify/storage';
import { S3Level } from 'models';

export const STORAGE_BUCKET = 'mhbucketportal';
export const STORAGE_REGION = 'us-east-1';

export const LOGO_PATH = 'logos/originals';
export const AVATAR_PATH = 'avatars/originals';

// v3 used 'public'; v6 uses 'guest' for the same access level
const toAccessLevel = (level: string): 'guest' | 'protected' | 'private' =>
  level === 'public' ? 'guest' : level as 'protected' | 'private';

class StorageService {
  saveFile = async (
    file: File,
    level: S3Level = S3Level.PRIVATE,
    path: string = '',
    identityId?: string | null,
    progressCallback?: (progress: any) => void,
  ): Promise<string | null> => {
    try {
      const key = `${path}/${file.name}`;

      await uploadData({
        key,
        data: file,
        options: {
          accessLevel: toAccessLevel(level.toLowerCase()),
          ...(progressCallback && {
            onProgress: ({ transferredBytes, totalBytes }: { transferredBytes: number; totalBytes?: number }) =>
              progressCallback({ loaded: transferredBytes, total: totalBytes }),
          }),
          ...(identityId && { targetIdentityId: identityId }),
        },
      }).result;

      return key;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('error uploading file!', err);

      return null;
    }
  };

  getImage = async (
    filename: string,
    level: S3Level = S3Level.PUBLIC,
    identityId?: string | null,
  ): Promise<string | object | null> => {
    try {
      const { url } = await getUrl({
        key: filename,
        options: {
          accessLevel: toAccessLevel(level.toLowerCase()),
          ...(identityId && { targetIdentityId: identityId }),
        },
      });

      return url.toString();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);

      return null;
    }
  };

  processStorageList = async (result: any) => {
    const files: any[] = [];
    const folders = new Set();
    result.forEach((res: any) => {
      if (res.size) {
        files.push(res);
        const possibleFolder = res.key.split('/').slice(0, -1).join('/');
        if (possibleFolder) folders.add(possibleFolder);
      } else {
        folders.add(res.key);
      }
    });

    return { files, folders };
  };
}

export default new StorageService();
